import { IReduxAction } from '../../../services/interfaces/common-interface';
import {
  SET_LOADING_DATA,
  SET_LOADING_SEND,
  GET_BY_ID_SUCCESS,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_ORIENTATION,
  SET_ORDER,
  SET_ORDERBY,
  GET_ALL_SUCCESS,
  SET_LOADING_LIST,
  TEST_TENANT_CONNECTION_LOADING
} from './tenant-constants';

const INITIAL_STATE: any = {
  loadingData: true,
  loadingList: true,
  loadingSend: false,
  loadingTestConnection: false,
  list: {
    hasRemotePagination: true,
    allRows: [],
    rows: [],
    rowsCount: 0,
    page: 0,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    order: 'asc',
    orderBy: 'createdAt'
  }
};

const tenantReducer = (state: any = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          page: action.page
        }
      };
    }

    case SET_ROWS_PER_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsPerPage: action.rowsPerPage
        }
      };
    }

    case SET_ROWS_COUNT: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsCount: action.rowsCount
        }
      };
    }

    case SET_ROWS_ORIENTATION: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsOrientation: action.rowsOrientation
        }
      };
    }

    case SET_ORDER: {
      return {
        ...state,
        list: {
          ...state.list,
          order: action.order
        }
      };
    }

    case SET_ORDERBY: {
      return {
        ...state,
        list: {
          ...state.list,
          orderBy: action.orderBy
        }
      };
    }

    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case SET_LOADING_LIST: {
      return {
        ...state,
        loadingList: action.loading
      };
    }

    case SET_LOADING_SEND: {
      return {
        ...state,
        loadingSend: action.loading
      };
    }

    case GET_BY_ID_SUCCESS: {
      return {
        ...state,
        ...action.payload
      };
    }

    case TEST_TENANT_CONNECTION_LOADING: {
      return {
        ...state,
        loadingTestConnection: action.payload
      };
    }

    case GET_ALL_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: action.payload.rows,
          allRows: action.payload.rows,
          rowsCount: action.payload.count ?? state?.list?.rowsCount
        }
      };
    }

    default:
      return state;
  }
};

export default tenantReducer;
